export default "__VITE_ASSET__BEXa$d$L__"